
import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { Router } from '@angular/router';
import { GraphqlService } from '../../common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpcallService } from '../../common/services/httpcall.service';
import { forkJoin, Subscription } from 'rxjs';
import { OpenLinkById } from 'src/app/common/services/openlinkbyid';
import { constObj } from 'src/app/common/Constants/constants';
import { SessionService } from '../../common/services/Session.service';
import { OpenLeftNavLinkService } from 'src/app/common/services/open-left-nav-link.service';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  constructor(private route: Router,
    private commonDataService: CommonDataService,
    public loginService: LoginService,
    private graphQlService: GraphqlService,
    private sanitizer: DomSanitizer,
    private graphQLService: GraphqlService,
    private openlink: OpenLinkById, private session: SessionService,
    private httpCall: HttpcallService, private openleftnavlink: OpenLeftNavLinkService, private searchroute: ActivatedRoute) { }
  elasticSearchCondition = {
    Searchterm: "",
    SourceType: "",
    Area: [],
    Topic: [],
    TopicId:[],
    ContentType: [],
    OtherSourceDocType:[],
    pdfSource:[]
  };

  elasticSearchTopicCondition = {
    Searchterm: "",
    SourceType: "",
    Area: [],
    Topic: [],
    TopicId:[],
    ContentType: []
  };
  isButtonActive: boolean = false;
  recentSearchTerm
  showingResults;
  NoResults;
  ReviewText;
  recent;
  Example1;
  Example2;
  ResultsRelated;
  Glossary;
  MyAnnotations;
  MyBookmarks;
  MyFeedback;
  NarrowTopic;
  /*ReviewExamples;*/
  paragraphHeader;
  sectionHeader;
  topicsHeader;
  glossaryToolsHeader;
  otherSourceHeader:string;
  searchHeading;
  samplePara1;
  samplePara2;
  samplePara3;
  sourceType;
  narrowResults;
  contentType;
  otherSourcesRadioButton;
  codificationRadioButton;
  narrowResult1;
  narrowResult2;
  narrowResult3;
  narrowResult4;
  contentType1;
  contentType2;
  inputIntegerated;
  relatedSearch; relatedTopic;
  paragraph: boolean = false;
  topics: boolean = false;
  other: boolean = false;
  otherSource:boolean=false;
  selectedParagraphArea: any = [];
  selectedTopicArea: any = [];
  selectedOtherArea: any = [];
  selectedOtherSourceArea: any = [];
  selectedTopic: any = [];
  otherAreaResult:any=[];
  paragraphAreaResult:any=[];
  topicAreaResult:any=[];
  OtherSourceAreaResult:any=[];
  topicResult:any=[];
  paragraphContentTypeResult:any=[];
  topicContentTypeResult:any=[];
  selectedParagraphContentType: any = [];
  selectedTopicContentType: any = [];
  selectedOtherContentType: any = [];
  numberOfResult: number = 0;
  paragraphSearchResult:any=[];
  tempParagraphSearchResult:any=[];
  otherSourceSearchResult:any=[];
  tempOtherSourceSearchResult:any=[];
  glossarySearchResult:any=[];
  tempGlossarySearchResult;
  paragraphResultCount: number = 0;
  topicResultCount: number = 0;
  glossaryResultCount: number = 0;
  annotationCount: number = 0;
  bookmarkCount: number = 0;
  otherSourceResultCount: number = 0;
  otherCount: number = 0;
  category: number = 0;
  emailId;
  role;
  topicSearchResult: any = [];
  tempTopicSearchResult: any = [];
  subtopicData: any;
  outcomeStatus: boolean = false;
  resultRelatedTo: any;
  topic:any;
  contacts:any=[];
  tempContacts:any=[];
  body:any;
  title: any;
  resetButton: string = "";
  totalParagraphResultCount: number = 0;
  totalTopicResultCount: number = 0;
  totalOtherSourceResultCount: number = 0;
  result_loadmore;
  result_recentsearchterm;
  PlaceholderLabel: string = "";
  paragraphFilterExists:boolean=false;
  topicFilterExists:boolean=false;
  otherFilterExists:boolean=false;
  pdfSearchResult: any = [];
  pdfSearchResultCount: number = 0;
  tempPdfSearchResult: any = [];
  totalPdfSearchResultCount: number = 0;
  filter: string = "";
  isFilterLocked = false;
  filterSort: string = "";
  filterSortByNumber: string = "";
  filterSortByLeftNav: string = "";
  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
   
    this.commonDataService.searchPageRefresh.subscribe(() => {
      if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
        this.loginService.getSession().subscribe(data => {
          this.emailId = data.user.email;
          this.role = data.user.roles;
          //this.getSearchInputValues();
          this.session.assignUserInfo(data.user);
        })
      }
      else {
        this.emailId = this.session.userInfo.user.email;
        this.role = this.session.userInfo.user.roles;
        //this.getSearchInputValues();
      }
    });
    this.getsearchlabels();
    this.paragraph = true;
    this.selectedParagraphArea = [];
    this.selectedTopicArea = [];
    this.selectedTopic = [];
    this.selectedParagraphContentType = [];
    this.selectedTopicContentType = [];
    this.selectedOtherContentType = [];
    const searchTerm = this.searchroute.snapshot.queryParamMap.get('query');
    this.searchNewTerm(searchTerm);

  }


  

  //  ngOnDestroy(): void {
  //    localStorage.removeItem("ElasticSearchTerm");
  //  }
 

  getsearchlabels() {
    this.graphQlService.getSearchLabels().subscribe(data => {
      if (data != "") {
        var labels = data?.content?.data?.labels;
        labels = labels.filter(x => x.key.trim());
        this.paragraphHeader = labels.filter(x => x.key == "search_paragraphText").map(y => y.value);
        this.sectionHeader = labels.filter(x => x.key == "search_sectionText").map(y => y.value);
        this.topicsHeader = labels.filter(x => x.key == "search_topicText").map(y => y.value);
        this.glossaryToolsHeader = labels.filter(x => x.key == "search_glossary_and_tools_Text").map(y => y.value);
        this.sourceType = labels.filter(x => x.key == "search_SourceType").map(y => y.value);
        this.narrowResults = labels.filter(x => x.key == "search_NarrowResult").map(y => y.value);
        this.contentType = labels.filter(x => x.key == "search_ContentType").map(y => y.value);
        this.relatedSearch = labels.filter(x => x.key == "search_SearchesRelated").map(y => y.value);
        this.codificationRadioButton = labels.filter(x => x.key == "search_Codification").map(y => y.value);
        this.otherSourcesRadioButton = labels.filter(x => x.key == "search_OtherSources").map(y => y.value);
        this.narrowResult1 = labels.filter(x => x.key == "search_Presentation").map(y => y.value);
        this.narrowResult2 = labels.filter(x => x.key == "search_Assets").map(y => y.value);
        this.narrowResult3 = labels.filter(x => x.key == "search_Liability").map(y => y.value);
        this.narrowResult4 = labels.filter(x => x.key == "search_Revenue").map(y => y.value);
        this.contentType1 = labels.filter(x => x.key == "search_Fasb").map(y => y.value);
        this.contentType2 = labels.filter(x => x.key == "search_Sec").map(y => y.value);
        this.showingResults = labels.filter(x => x.key == "search_ShowingResults").map(y => y.value);
        this.NoResults = labels.filter(x => x.key == "search_NoResults").map(y => y.value);
        this.ReviewText = labels.filter(x => x.key == "search_ReviewText").map(y => y.value);
        this.recent = labels.filter(x => x.key == "search_recent").map(y => y.value);
        this.Example1 = labels.filter(x => x.key == "search_Example1").map(y => y.value);
        this.Example2 = labels.filter(x => x.key == "search_Example2").map(y => y.value);
        this.ResultsRelated = labels.filter(x => x.key == "search_ResultsRelated").map(y => y.value);
        this.Glossary = labels.filter(x => x.key == "search_Glossary").map(y => y.value);
        this.MyAnnotations = labels.filter(x => x.key == "search_MyAnnotations").map(y => y.value);
        this.MyBookmarks = labels.filter(x => x.key == "search_MyBookmarks").map(y => y.value);
        this.MyFeedback = labels.filter(x => x.key == "search_MyFeedback").map(y => y.value);
        this.NarrowTopic = labels.filter(x => x.key == "search_NarrowTopic").map(y => y.value);
        this.resultRelatedTo = labels.filter(x => x.key == "result_related_to").map(y => y.value);
        this.otherSourceHeader=labels.filter(x => x.key == "search_otherSourceText").map(y => y.value);
        /*this.ReviewExamples = labels.filter(x => x.key == "search_ReviewExamples").map(y => y.value);*/
        this.result_loadmore = labels.filter(x => x.key == "result_loadmore").map(y => y.value);
        this.result_recentsearchterm = labels.filter(x => x.key == "result_recentsearchterm").map(y => y.value);
        this.filterSort = labels.filter(x => x.key == "filter_sort").map(y => y.value);
        this.filterSortByNumber = labels.filter(x => x.key == "filter_sortByNumber").map(y => y.value);
        this.filterSortByLeftNav = labels.filter(x => x.key == "filter_sortByLeftNav").map(y => y.value);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

  redirectToBookmarkUrl(bookmark) {
    this.route.navigateByUrl(bookmark.bookmarkURL);
  }

  redirectToAnnotationUrl(annotation) {
    this.route.navigateByUrl(annotation.annotationsURL);
  }

  searchNewTerm(term: string)
  {
    localStorage.setItem("ElasticSearchTerm", term);
    this.getSearchInputValues();
  }
  
  ngAfterContentChecked() {
    this.EnableBackToTop();
    this.addPendingContent();
  }
  
  paragraphPageCount:number=0;
  topicPageCount: number = 0;
  otherPageCount: number = 0;
  othersourcePageCount: number = 0;
  totalGlossaryCount:number=0;
  pdfPageCount: number = 0;
  secDefinition = constObj.secDefinition;
  isFullyLoaded: boolean;
  totalOtherCount: number = 0;
  pdfSearchFilterResults:any=[];

  getSearchInputValues() {
    this.outcomeStatus=false;
    this.commonDataService.showLoader.next(true);
    this.elasticSearchCondition={
    Searchterm: "",
    SourceType: "",
    Area: [],
    Topic: [],
    TopicId:[],
    ContentType: [],
    OtherSourceDocType:[],
    pdfSource:[]
    }
    
    this.elasticSearchTopicCondition={
      Searchterm: "",
      SourceType: "",
      Area: [],
      Topic: [],
      TopicId:[],
      ContentType: []
      }
  
    this.paragraph = true;
    this.topics=false;
    this.other=false;
    this.otherSource=false;
    this.selectedParagraphArea = [];
    this.selectedTopicArea = [];
    this.selectedTopic = [];
    this.selectedParagraphContentType = [];
    this.selectedTopicContentType = [];
    this.selectedOtherContentType = [];
    this.selectedPdfFilter = [];
    this.selectedPdfSource = [];
    this.selectedOtherSourceArea = [];
    this.contacts = [];
    this.paragraphSearchResult = [];

    this.otherPageCount=0;
    this.topicPageCount=0;
    this.paragraphPageCount=0;
    this.othersourcePageCount=0;
    this.category=0;
    this.elasticSearchCondition.Searchterm = localStorage.getItem("ElasticSearchTerm");
    this.elasticSearchTopicCondition.Searchterm = localStorage.getItem("ElasticSearchTerm");
    this.PdfChecked=false;
    this.isFullyLoaded=false;

    this.totalOtherCount=0;
    this.totalGlossaryCount=0;
    this.totalOtherSourceCount=0;
    this.totalOtherSourceResultCount=0;
    this.totalParagraphResultCount=0;
    this.totalPdfSearchResultCount=0;
    this.totalTopicResultCount=0;
    this.annotationCount=0;
    this.bookmarkCount=0;
    this.paragraphSearchResult=[];
    this.topicSearchResult=[];
    this.otherSourceSearchResult=[];
    this.pdfSearchResult=[];
    this.annotationResult=[];
    this.bookmarkResult=[];
    this.glossarySearchResult=[];


    this.graphQlService.GetParagraphElasticSearchReasult(this.elasticSearchCondition,this.paragraphPageCount).subscribe(pargarphRessult=>{
      if(pargarphRessult){
        this.paragraph = true;
        this.radioHitBased = true;
        this.radioleftNav = false;
      this.paragraphAreaResult = pargarphRessult?.aggregations?.areas?.buckets;
      this.paragraphContentTypeResult = pargarphRessult?.aggregations?.contentTypes?.buckets;
      this.paragraphSearchResult = pargarphRessult?.hits?.hitsList; this.paragraphResultCount = pargarphRessult?.hits?.hitsList?.length;
        this.tempParagraphSearchResult = this.paragraphSearchResult; this.totalParagraphResultCount = pargarphRessult?.hits?.total?.value;

        //Start -- Added by Sagar for FPP-58
        // Logic to get all hilighted terms of elastic search response.
        localStorage.setItem("searchTerm", localStorage.getItem("ElasticSearchTerm"));
        //console.log(this.paragraphSearchResult)
        const parser = new DOMParser();
        let keywords = new Set(); // Using set to avoid duplication of terms
        for (let item of this.paragraphSearchResult) {
          let htmlStringBody = item["source"]["body"];
          const doc = parser.parseFromString(htmlStringBody, 'text/html');
          const hilightedElement = doc.getElementsByClassName('highlightSearchTerm') as HTMLCollectionOf<HTMLSpanElement>;
          if (hilightedElement != null && hilightedElement != undefined && hilightedElement.length > 0) {
            for (let j = 0; j < hilightedElement.length; j++) {
              keywords.add(hilightedElement[j].innerText);
            }
          }
        }
        localStorage.setItem("hilightedElasticTerms", Array.from(keywords).toString());
        //End -- Added by Sagar for FPP-58
      this.numberOfResult =this.isFullyLoaded?this.totalParagraphResultCount + this.totalTopicResultCount + this.totalOtherCount + this.totalOtherSourceCount: this.totalParagraphResultCount;
        if (this.paragraphResultCount > 0) { this.category++; }
        // this.showingResults[0].replace("[0]", this.numberOfResult).replace("[1]", this.category);
        this.outcomeStatus = true;
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
    
    if (this.role != "Professional") {
      forkJoin(
        this.graphQlService.GetTopicSearchResults(this.elasticSearchTopicCondition,this.topicPageCount),
        this.graphQLService.GetMasterGlossarySearchResult(this.elasticSearchCondition.Searchterm,this.otherPageCount),
        // this.graphQLService.GetGlossarySearch(this.elasticSearchCondition.Searchterm),
        //this.httpCall.getRecentSearchTerm(this.emailId),
        this.graphQlService.GetOtherSourceSearchResults(this.elasticSearchCondition,this.othersourcePageCount)
        // this.graphQlService.GetPdfSearchResults(this.elasticSearchCondition,this.pdfPageCount)
       ).subscribe(([topicResult, glossary, otherSourceResult]) => {

      // ).subscribe(([topicResult, glossary, recentSearchTerm, otherSourceResult,pdfSearchResult]) => {
        this.topicAreaResult = topicResult?.aggregations?.areas?.buckets;
        this.topicContentTypeResult = topicResult?.aggregations?.contentTypes?.buckets;
        this.topicSearchResult=topicResult?.hits?.hitsList; this.topicResultCount=topicResult?.hits?.hitsList?.length; 
        this.tempTopicSearchResult=this.topicSearchResult; this.totalTopicResultCount=topicResult?.aggregations?.total?.value;
        this.otherSourceSearchResult=otherSourceResult?.hits?.hitsList; this.otherSourceResultCount=otherSourceResult?.hits?.hitsList?.length; 
        this.tempOtherSourceSearchResult=this.otherSourceSearchResult; this.totalOtherSourceResultCount=otherSourceResult?.hits?.total?.value;
        this.OtherSourceAreaResult=otherSourceResult?.aggregations?.otherSourceDocTypes?.buckets;
        // this.tempPdfSearchResult=pdfSearchResult?(pdfSearchResult.hits?.hitsList):[]; this.totalPdfSearchResultCount=pdfSearchResult?(pdfSearchResult.hits?.total?.value):0;
        // if (this.totalOtherSourceResultCount == 0 || this.totalOtherSourceResultCount == this.otherSourceResultCount) {
        //   this.pdfSearchResult=this.tempPdfSearchResult;
        // }
        // this.pdfSearchResultCount=pdfSearchResult?pdfSearchResult.hits?.hitsList?.length:0;
        //  this.pdfSearchFilterResults=pdfSearchResult?.aggregations?.pdfSources?.buckets;
         if(this.pdfSearchFilterResults!=null){
          this.pdfSearchFilterResults.forEach(ele => {
            if(ele.key.toLowerCase().includes("superseded")){
              ele.key="Pre-Cod Standards"
            }
            else if(ele.key.toLowerCase().includes("conceptstatments")){
              ele.key="Concepts Statements"
            }
          });
         }
        this.tempGlossarySearchResult = glossary?.hits?.hitsList; this.glossarySearchResult = this.tempGlossarySearchResult;
        this.totalGlossaryCount=glossary?.hits?.total?.value; this.glossaryResultCount = glossary?.hits?.hitsList?.length;
        this.totalOtherSourceCount=this.totalPdfSearchResultCount+this.totalOtherSourceResultCount; 
        this.otherSourceCount=this.totalOtherSourceResultCount == 0 || this.totalOtherSourceResultCount == this.otherSourceResultCount?this.pdfSearchResultCount+this.otherSourceResultCount:this.otherSourceResultCount;
        this.totalOtherCount=this.totalGlossaryCount;
        this.otherCount = this.glossaryResultCount; this.mapGlossaryContent(this.glossarySearchResult); 
        this.tempTotalParagraphResultCount=this.totalParagraphResultCount; this.tempTotalTopicResultCount=this.totalTopicResultCount;
        this.numberOfResult = this.totalParagraphResultCount  +this.totalTopicResultCount + this.totalOtherCount +this.totalOtherSourceCount;
        this.isFullyLoaded=true;
        if (this.topicResultCount > 0) { this.category++; }
        if (this.otherCount > 0) { this.category++; }
        if (this.totalOtherSourceCount > 0) { this.category++; }
        //this.recentSearchTerm = recentSearchTerm;
        //this.outcomeStatus = true;
        //this.commonDataService.showLoader.next(false);
         this.isFilterLocked = false;
      })
    }
    else {
      forkJoin(
        this.graphQlService.GetTopicSearchResults(this.elasticSearchTopicCondition,this.topicPageCount),
        this.httpCall.getElasticAnnotation(this.elasticSearchCondition.Searchterm, "", ""),
        this.httpCall.getElasticBookmark(this.elasticSearchCondition.Searchterm, "", ""),
        this.graphQLService.GetMasterGlossarySearchResult(this.elasticSearchCondition.Searchterm,this.otherPageCount),
        // this.graphQLService.GetGlossarySearch(this.elasticSearchCondition.Searchterm),
        this.httpCall.getRecentSearchTerm(),
        this.graphQlService.GetOtherSourceSearchResults(this.elasticSearchCondition,this.othersourcePageCount)
        // this.graphQlService.GetPdfSearchResults(this.elasticSearchCondition,this.pdfPageCount)

      // ).subscribe(([topicResult, annotation, bookmarks, glossary, recentSearchTerm,otherSourceResult,pdfSearchResult]) => {
       ).subscribe(([topicResult, annotation, bookmarks, glossary, recentSearchTerm,otherSourceResult]) => {

        this.topicAreaResult = topicResult?.aggregations?.areas?.buckets;
        this.topicContentTypeResult = topicResult?.aggregations?.contentTypes?.buckets;
        this.topicSearchResult=topicResult?.hits?.hitsList; this.topicResultCount=topicResult?.hits?.hitsList?.length; 
        this.tempTopicSearchResult=this.topicSearchResult; this.totalTopicResultCount=topicResult?.aggregations?.total?.value;
        this.otherSourceSearchResult=otherSourceResult?.hits?.hitsList; this.otherSourceResultCount=otherSourceResult?.hits?.hitsList?.length; 
        this.tempOtherSourceSearchResult=this.otherSourceSearchResult; this.totalOtherSourceResultCount=otherSourceResult?.hits?.total?.value;
        this.OtherSourceAreaResult=otherSourceResult?.aggregations?.otherSourceDocTypes?.buckets;
         this.tempannotationResult = annotation;this.annotationCount = this.tempannotationResult.length;
         this.tempBookmarkResult = bookmarks; this.bookmarkCount = this.tempBookmarkResult.length;
        //  this.tempPdfSearchResult=pdfSearchResult?(pdfSearchResult.hits?.hitsList):[]; this.totalPdfSearchResultCount=pdfSearchResult?(pdfSearchResult.hits?.total?.value):0;
        // if (this.totalOtherSourceResultCount == 0 || this.totalOtherSourceResultCount == this.otherSourceResultCount) {
        //   this.pdfSearchResult=this.tempPdfSearchResult;
        // }
        // this.pdfSearchResultCount=pdfSearchResult?pdfSearchResult.hits?.hitsList?.length:0;
        //  this.pdfSearchFilterResults=pdfSearchResult?.aggregations?.pdfSources?.buckets;
        var searchTerm = { "Id": "-1", "SearchKeyword": this.elasticSearchCondition.Searchterm, "Application": "", "CreateDate": "", "UpdateDate": "", "UpdateUserId": "", "IsActive": true }
        this.httpCall.addSearchTerm(searchTerm).subscribe(data => console.log(data));

         if(this.pdfSearchFilterResults!=null){
          this.pdfSearchFilterResults.forEach(ele => {
            if(ele.key.toLowerCase().includes("superseded")){
              ele.key="Pre-Cod Standards"
            }
            else if(ele.key.toLowerCase().includes("conceptstatments")){
              ele.key="Concepts Statements"
            }
          });
         }
        this.totalOtherSourceCount=this.totalPdfSearchResultCount+this.totalOtherSourceResultCount; 
        this.otherSourceCount=this.totalOtherSourceResultCount == 0 || this.totalOtherSourceResultCount == this.otherSourceResultCount?this.pdfSearchResultCount+this.otherSourceResultCount:this.otherSourceResultCount;
        //this.otherSourceCount = this.otherSourceResultCount;
        this.setOtherAreaResult();
        this.tempGlossarySearchResult = glossary?.hits?.hitsList; this.glossarySearchResult = this.tempGlossarySearchResult; this.totalGlossaryCount=glossary?.hits?.total?.value;
        this.mapGlossaryContent(this.glossarySearchResult); this.glossaryResultCount = glossary?.hits?.hitsList?.length;
        if (this.totalGlossaryCount == this.glossaryResultCount) {
          this.annotationResult = this.tempannotationResult; 
          this.bookmarkResult = this.tempBookmarkResult; 
        }
        this.totalOtherCount=this.annotationCount+this.bookmarkCount+this.totalGlossaryCount
        this.otherCount = this.annotationCount + this.bookmarkCount + this.glossaryResultCount;
        this.tempTotalParagraphResultCount=this.totalParagraphResultCount; this.tempTotalTopicResultCount=this.totalTopicResultCount;
         this.numberOfResult = this.totalParagraphResultCount + this.totalTopicResultCount + this.totalOtherCount + this.totalOtherSourceCount;
        this.isFullyLoaded=true;
        if (this.topicResultCount > 0) { this.category++; }
        if (this.totalOtherCount > 0) { this.category++; }
        if (this.totalOtherSourceCount > 0) { this.category++; }
        // this.showingResults[0].replace("[0]", this.numberOfResult).replace("[1]", this.category);
        this.recentSearchTerm = recentSearchTerm;
        // this.outcomeStatus = true;
        // this.commonDataService.showLoader.next(false);
         this.isFilterLocked = false;
      })
    }

    var i, tablinks;

    tablinks=Array.from(document.getElementsByClassName("tablinks") as HTMLCollectionOf<HTMLElement>)
    if(tablinks.length>0){
      tablinks.forEach((tab,index)=>{
        if(index==0){
          tab.className+=" active";
        }
        else{
          tab.className = tab.className.replace(" active", "");
        }
      })
    }
  
    if( document.getElementById("myButton")){
      document.getElementById("myButton").style.display = "block";
    }
    
  }
  distinctTopics:any=[];
  mapGlossaryContent(data) {
    if (data) {
      data.forEach(element => {
        this.topic = [];
        this.distinctTopics=[];
        let source = element.source;
        this.title = source.title;
         this.body = source.body;
        if (source.usage != null) {
          source.usage.forEach(usage => {
            this.topic.push(usage);
          });
        }
        var count=0;
        if(this.topic.length>0){
          this.topic.forEach(topicRes => {
            if (topicRes.topic != null && topicRes.topic != undefined) {
              if (count == 0) {
                let obj = {
                  topic: topicRes.topic,
                  topicData: [topicRes]
                }
                this.distinctTopics.push(obj);
                count++;
              }
              else {
                var topics = this.distinctTopics.filter(x => x.topic == topicRes.topic);
                if (topics.length > 0) {
                  this.distinctTopics.filter(x => x.topic == topicRes.topic)[0].topicData.push(topicRes);
                }
                else {
                  let obj = {
                    topic: topicRes.topic,
                    topicData: [topicRes]
                  }
                  this.distinctTopics.push(obj);
                }
                count++;
              }
            }
          })
        }
        this.distinctTopics=this.distinctTopics.sort((a, b) => (a.topic < b.topic) ? -1 : 1);
        var content = { name: this.title, capital: this.body,topic:this.topic ,seetopic: this.distinctTopics ,type:source.glossaryType};
        this.contacts.push(content);
      });
      // this.contacts.sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
      this.contacts.sort((a, b) => this.sortAlphaName(a.name.toLowerCase().replace(/[^a-z0-9]/g, ""), b.name.toLowerCase().replace(/[^a-z0-9]/g, "")) ? -1 : 1)
      this.tempContacts=this.contacts;
      this.glossaryResultCount=this.contacts.length;
    }
  }

  sortAlphaName(a: any, b: any) {
    let comparatorResult = 0;
    let spanA = document.createElement("span");
    spanA.innerHTML = a.section;
    let x = spanA.innerText.trim().toLowerCase();
    let spanB = document.createElement("span");
    spanB.innerHTML = b.section;
    let y = spanB.innerText.trim().toLowerCase();
    return x > y;
  }

  // CasingConverter(obj) {
  //   obj.forEach(data=>{
  //     data.key = data.key.toLowerCase()
  //     .split(' ')
  //     .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
  //     .join(' ');
  //   })
  //   return obj;
  // }

  tempTotalParagraphResultCount:number=0;
  tempTotalTopicResultCount:number=0;
  getParagraphElasticResults()
  {
    this.graphQlService.GetParagraphElasticSearchReasult(this.elasticSearchCondition,this.paragraphPageCount).subscribe(data => { 
      this.paragraphSearchResult = data?.hits?.hitsList; 
      this.totalParagraphResultCount= data?.hits?.total?.value; 
      this.paragraphResultCount=data?.hits?.hitsList?.length;
      this.tempParagraphSearchResult = this.paragraphSearchResult;
    })
  }

  getTopicElasticResults()
  {
    this.graphQlService.GetTopicSearchResults(this.elasticSearchTopicCondition,this.topicPageCount).subscribe(data => {
      this.topicSearchResult = data?.hits?.hitsList; 
      this.topicResultCount=data?.hits?.hitsList?.length;
      this.totalTopicResultCount=data?.aggregations?.total?.value;
      this.tempTopicSearchResult=this.topicSearchResult;
    })
  }

  getOtherSourceElasticResults()
  {
    this.graphQlService.GetOtherSourceSearchResults(this.elasticSearchCondition,this.othersourcePageCount).subscribe(otherSourceResult => {
      this.otherSourceSearchResult=otherSourceResult?.hits?.hitsList; 
      this.otherSourceResultCount=otherSourceResult?.hits?.hitsList?.length; 
      this.totalOtherSourceResultCount=otherSourceResult?.hits?.total?.value;
      this.tempOtherSourceSearchResult=this.otherSourceSearchResult;
      this.getOtherSourceTabResult();
      })
  }

  getPdfElasticResults()
  {
    this.commonDataService.showLoader.next(true);
    this.graphQlService.GetPdfSearchResults(this.elasticSearchCondition,this.pdfPageCount).subscribe(pdfResult => {
      this.pdfSearchResult=pdfResult?.hits?.hitsList; 
      this.pdfSearchResultCount=pdfResult?.hits?.hitsList?.length; 
      this.totalPdfSearchResultCount=pdfResult?.hits?.total?.value;
      this.getOtherSourceTabResult();
      this.commonDataService.showLoader.next(false);
      })
  }

getSubtopicResults(topic:any){
  this.elasticSearchTopicCondition.Topic=[];
     this.elasticSearchTopicCondition.Topic.push({
      area:topic.area,
      topicId:topic.topicId.toString(),
      topicTitle:topic.topicTitle
    })
    this.commonDataService.elasticSearchTopicData.next(this.elasticSearchTopicCondition);
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightOverlayOption.next("searchPage");
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
}
  glossaryTermUsage: string = "";
  seeTopics: string = "";
  annotationResult;
  tempannotationResult;
  bookmarkResult;
  tempBookmarkResult;
  searchContent(evt, searchValue) {
    var tabCount;
    this.commonDataService.showLoader.next(true);
    if (searchValue == "paragraph") {
      this.paragraph = true;
      this.topics = false;
      this.other = false;
      this.otherSource=false;
      this.getParagraphCheckedStatus();
      tabCount = document.getElementById("paragraphCount");
      if (tabCount != null) {
        tabCount.className = tabCount.className.replace("lightGrey-color", "");
      }
      this.setTopicsTabCountStylings();
      this.setOthersTabCountStylings();
      this.setOtherSourceTabCountStylings();
    }
    if (searchValue == "topics") {
      this.topics = true;
      this.other = false;
      this.paragraph = false;
      this.otherSource=false;
      this.getTopicCheckedStatus();
      tabCount = document.getElementById("topicsCount");
      if (tabCount != null) {
        tabCount.className = tabCount.className.replace("lightGrey-color", "");
      }
      this.setParagraphTabCountStylings();
      this.setOthersTabCountStylings();
      this.setOtherSourceTabCountStylings();
    }
    if (searchValue == "others") {
      this.other = true;
      this.paragraph = false;
      this.topics = false;
      this.otherSource=false;
      this.getOtherAreaResultCheckedStatus();
      tabCount = document.getElementById("othersCount");
      if (tabCount != null) {
        tabCount.className = tabCount.className.replace("lightGrey-color", "");
      }
      this.graphQlService.getGlobalLabels().subscribe(data => {
        if (data != "") {
          var labels = data.content.data.labels;
          labels = labels.filter(x => x.key.trim());
          this.glossaryTermUsage = labels.filter(x => x.key == "glossary_termUsage").map(y => y.value);
          this.seeTopics = labels.filter(x => x.key == "glossary_see").map(y => y.value);
        }
      })
      this.setParagraphTabCountStylings();
      this.setTopicsTabCountStylings();
      this.setOtherSourceTabCountStylings();
    }
    if (searchValue == "othersource") {
      this.other = false;
      this.paragraph = false;
      this.topics = false;
      this.otherSource=true;
      this.getOtherSourceCheckedStatus();
      tabCount = document.getElementById("othersourceCount");
      if (tabCount != null) {
        tabCount.className = tabCount.className.replace("lightGrey-color", "");
      }
      this.setParagraphTabCountStylings();
      this.setTopicsTabCountStylings();
      this.setOthersTabCountStylings();
    }
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("glossaryTabContent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById("myButton").style.display = "block";
    evt.currentTarget.className += " active";
    this.commonDataService.showLoader.next(false);
  }

  setParagraphTabCountStylings(){
    var tabCount = document.getElementById("paragraphCount");
    if (tabCount != null && !tabCount.className.includes("lightGrey-color")) {
      tabCount.className += " lightGrey-color";
    }
  }

  setTopicsTabCountStylings(){
    var tabCount = document.getElementById("topicsCount");
    if (tabCount != null && !tabCount.className.includes("lightGrey-color")) {
      tabCount.className += " lightGrey-color";
    }
  }

  setOthersTabCountStylings(){
    var tabCount = document.getElementById("othersCount");
    if (tabCount != null && !tabCount.className.includes("lightGrey-color")) {
      tabCount.className += " lightGrey-color";
    }
  }

  setOtherSourceTabCountStylings(){
    var tabCount = document.getElementById("othersourceCount");
    if (tabCount != null && !tabCount.className.includes("lightGrey-color")) {
      tabCount.className += " lightGrey-color";
    }
  }
  //getSearchLabels
  getParagraphCheckedStatus() {
    this.selectedTopic.forEach(x => {
      var Topicindex = this.topicResult.findIndex((obj => obj.key == x));
      this.topicResult[Topicindex].checked = true;
    });
    this.selectedParagraphArea.forEach(x => {
      var areaindex = this.paragraphAreaResult.findIndex((obj => obj.key == x));
      this.paragraphAreaResult[areaindex].checked = true;
    });
    this.selectedParagraphContentType.forEach(x => {
      var paraContentTypeIndex = this.paragraphContentTypeResult.findIndex((obj => obj.key == x));
      this.paragraphContentTypeResult[paraContentTypeIndex].checked = true;
    });
    
  }
  radioHitBased: boolean = true;
  radioleftNav: boolean = false;
  onFilterOrderChange(filter) {

    if (filter == "hitBased") {
      this.radioHitBased = true;
      this.radioleftNav = false;
      this.paragraphAreaResult = this.paragraphAreaResult.sort((a, b) => b.docCount - a.docCount);
      this.topicAreaResult = this.topicAreaResult.sort((a, b) => b.docCount - a.docCount);
      //this.OtherSourceAreaResult = this.OtherSourceAreaResult.sort((a, b) => b.docCount - a.docCount);
    }
    else {
      this.radioHitBased = false;
      this.radioleftNav = true;
      let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
      if (tempData != undefined && tempData != null) {
        const areaMap = new Map(tempData.map((o, index) => [o.item, index]))
        this.paragraphAreaResult = this.paragraphAreaResult.sort((a, b) => {
          const indexA: number = Number(areaMap.get(a.key) ?? Number.MAX_SAFE_INTEGER);
          const indexB: number = Number(areaMap.get(b.key) ?? Number.MAX_SAFE_INTEGER);
          return indexA - indexB;
        })

        this.topicAreaResult = this.topicAreaResult.sort((a, b) => {
          const indexA: number = Number(areaMap.get(a.key) ?? Number.MAX_SAFE_INTEGER);
          const indexB: number = Number(areaMap.get(b.key) ?? Number.MAX_SAFE_INTEGER);
          return indexA - indexB;
        })

        //const otherSourceMap = new Map(tempData[10].itemData.map((o, index) => [o.item.toLowerCase(), index]));
        //this.OtherSourceAreaResult = this.OtherSourceAreaResult.sort((a, b) => {
        //  const indexA: number = Number(otherSourceMap.get(a.key+'s') ?? Number.MAX_SAFE_INTEGER);
        //  const indexB: number = Number(otherSourceMap.get(b.key+'s') ?? Number.MAX_SAFE_INTEGER);
        //  return indexA - indexB;
        //})
      }
    }
  }

  getTopicCheckedStatus(){
    this.selectedTopicArea.forEach(x => {
      var topicAreaindex = this.topicAreaResult.findIndex((obj => obj.key == x));
      this.topicAreaResult[topicAreaindex].checked = true;
    });
    this.selectedTopicContentType.forEach(x => {
      var topicContentTypeIndex = this.topicContentTypeResult.findIndex((obj => obj.key == x));
      this.topicContentTypeResult[topicContentTypeIndex].checked = true;
    });
  }
   getOtherSourceCheckedStatus(){
    this.selectedOtherSourceArea.forEach(x => {
      var otherSourceAreaIndex = this.OtherSourceAreaResult.findIndex((obj => obj.key == x));
      this.OtherSourceAreaResult[otherSourceAreaIndex].checked = true;
    });
    // this.PdfChecked = (this.totalOtherSourceResultCount==0 && this.pdfSearchResultCount>0) || this.PdfChecked ? true : false;
     this.selectedPdfSource.forEach(source => {
      if(source=="superseded"){
        let pdfSourceAreaIndex = this.pdfSearchFilterResults.findIndex((obj => obj.key == "Pre-Cod Standards"));
        this.pdfSearchFilterResults[pdfSourceAreaIndex].checked = true;
      }
      else if(source=="ConceptStatments"){
        let pdfSourceAreaIndex1 = this.pdfSearchFilterResults.findIndex((obj => obj.key == "Concepts Statements"));
        this.pdfSearchFilterResults[pdfSourceAreaIndex1].checked = true;
      }
       
    })
  }
  checkedParaArea(event) {
    this.paragraphPageCount = 0;
    if(event.checked)
    {
      this.selectedParagraphArea.push(event.source.value);
    }
    else{
      this.selectedParagraphArea.forEach((value,index) => {
        if(value==event.source.value)
        {
          this.selectedParagraphArea.splice(index,1);
          this.paragraphAreaResult.filter(x=>x.key==event.source.value)[0].checked=false;
        }
      });
    }
    if (this.selectedParagraphArea.length == 0) {
      this.selectedTopic = [];
      this.elasticSearchCondition.TopicId = [];
    }

    this.elasticSearchCondition.Area = this.selectedParagraphArea;
    this.graphQLService.GetTopicAggregates(this.elasticSearchCondition).subscribe(data => { this.topicResult = data.aggregations.topicIds.buckets; this.topicResult.forEach(c => c.checked =false);});

    this.getParagraphElasticResults();

  }

  checkedTopicArea(event) {
    this.topicPageCount = 0;
    if(event.checked)
    {
      this.selectedTopicArea.push(event.source.value);
    }
    else{
      this.selectedTopicArea.forEach((value,index) => {
        if(value==event.source.value)
        {
          this.selectedTopicArea.splice(index,1);
          this.topicAreaResult.filter(x=>x.key==event.source.value)[0].checked=false;
        }
      });
    }

    this.elasticSearchTopicCondition.Area = this.selectedTopicArea;
    
    this.getTopicElasticResults();

  }

  PdfChecked:boolean=false;
  totalOtherSourceCount: number = 0;
  otherSourceCount: number = 0;
  checkedOtherSourceArea(event) {
    this.othersourcePageCount = 0;
    // if(event.source.value=="Pdf"){
    //   this.PdfChecked = event.checked ? true : false;
    // }
    // else{
      if(event.checked)
      {
        this.selectedOtherSourceArea.push(event.source.value);
      }
      else{
        this.selectedOtherSourceArea.forEach((value,index) => {
          if(value==event.source.value)
          {
            this.selectedOtherSourceArea.splice(index,1);
            this.OtherSourceAreaResult.filter(x=>x.key==event.source.value)[0].checked=false;
          }
        });
      }
    // }
   
    // if(this.PdfChecked){
    //   this.pdfSearchResult=this.tempPdfSearchResult;
    //   // this.getPdfElasticResults();
    // }
    this.elasticSearchCondition.OtherSourceDocType = this.selectedOtherSourceArea;
    
    this.getOtherSourceElasticResults();
    
   
  }

  selectedPdfSource: any = [];
  selectedPdfFilter: any = [];
  onChangeText() { }
  checkedpdfFilter(event){
    this.pdfPageCount = 0;
    if(event.checked)
    {
      this.selectedPdfFilter.push(event.source.value);
      if(event.source.value.includes("Pre-Cod Standards")){
        this.selectedPdfSource.push("superseded");
      }
      else if(event.source.value.includes("Concepts Statements")){
        this.selectedPdfSource.push("ConceptStatments");
      }
    }
    else{
      if(event.source.value.includes("Pre-Cod Standards")){
      this.selectedPdfSource.splice(this.selectedPdfSource.findIndex(x=>x=="superseded"),1)
      }
      else if(event.source.value.includes("Concepts Statements")){
        this.selectedPdfSource.splice(this.selectedPdfSource.findIndex(x=>x=="ConceptStatments"),1)
      }
      this.pdfSearchFilterResults.filter(x=>x.key==event.source.value)[0].checked=false;
      this.selectedPdfFilter.forEach((value, index) => {
        if (value == event.source.value) {
          this.selectedPdfFilter.splice(index, 1);
        }
      });
    }
    this.elasticSearchCondition.pdfSource = this.selectedPdfSource;
    this.getPdfElasticResults();
  }


  getOtherSourceTabResult(){
  // if(this.selectedOtherSourceArea.length >= 0 && this.PdfChecked==false){
  //     this.pdfSearchResult = [];
  //     this.totalOtherSourceCount=this.totalOtherSourceResultCount;
  //     this.otherSourceCount=this.otherSourceResultCount;
  //   }
  //   else if (this.selectedOtherSourceArea.length == 0 && this.PdfChecked) {
  //     this.otherSourceSearchResult = [];
  //     this.totalOtherSourceCount=this.totalPdfSearchResultCount;
  //     this.otherSourceCount=this.pdfSearchResultCount;
  //   }
  //   else if (this.selectedOtherSourceArea.length > 1 && this.PdfChecked) {
      
  //     this.totalOtherSourceCount = this.totalPdfSearchResultCount + this.totalOtherSourceResultCount;
  //     this.otherSourceCount = this.pdfSearchResultCount + this.otherSourceResultCount;
  //   }

    if(this.selectedOtherSourceArea.length > 0 && this.selectedPdfSource.length==0){
      this.pdfSearchResult = [];
      this.totalOtherSourceCount=this.totalOtherSourceResultCount;
      this.otherSourceCount=this.otherSourceResultCount;
    }
    else if (this.selectedOtherSourceArea.length == 0 && this.selectedPdfSource.length > 0) {
      this.otherSourceSearchResult = [];
      this.totalOtherSourceCount=this.totalPdfSearchResultCount;
      this.otherSourceCount=this.pdfSearchResultCount;
    }
    else if (this.selectedOtherSourceArea.length > 0 && this.selectedPdfSource.length > 0) {
      
      this.totalOtherSourceCount = this.totalPdfSearchResultCount + this.totalOtherSourceResultCount;
      this.otherSourceCount = this.pdfSearchResultCount + this.otherSourceResultCount;
    }
    else if (this.selectedOtherSourceArea.length == 0 && this.selectedPdfSource.length == 0) {
      this.otherSourceSearchResult = this.tempOtherSourceSearchResult;
      this.totalOtherSourceCount=this.totalOtherSourceResultCount + this.totalPdfSearchResultCount;
      this.otherSourceCount=this.otherSourceResultCount;
    }
  }

  checkedTopic(event) {
    this.paragraphPageCount=0;
    if (event.checked) {
      this.selectedTopic.push(event.source.value);
    }
    else {
      this.selectedTopic.forEach((value, index) => {
        if (value == event.source.value) {
          this.selectedTopic.splice(index, 1);
          this.topicResult.filter(x=>x.key==event.source.value)[0].checked=false;
        }
      });
    }
    this.elasticSearchCondition.TopicId = this.selectedTopic;
    this.paragraphFilterExists=(this.elasticSearchCondition.Area.length!=0 || this.elasticSearchCondition.TopicId.length!=0 || this.elasticSearchCondition.ContentType.length!=0)?true:false;

    this.getParagraphElasticResults();
  }

  checkedParagraphContentType(event){
    this.paragraphPageCount=0;
    if(event.checked)
    {
      this.selectedParagraphContentType.push(event.source.value);
    }
    else{
      this.selectedParagraphContentType.forEach((value,index) => {
        if(value==event.source.value)
        {
          this.selectedParagraphContentType.splice(index,1);
          this.paragraphContentTypeResult.filter(x=>x.key==event.source.value)[0].checked=false;
        }
      });
    }
    this.elasticSearchCondition.ContentType=this.selectedParagraphContentType;
    this.getParagraphElasticResults();
  }

  checkedTopicContentType(event){
    this.topicPageCount=0;
    if(event.checked)
    {
      this.selectedTopicContentType.push(event.source.value);
    }
    else{
      this.selectedTopicContentType.forEach((value,index) => {
        if(value==event.source.value)
        {
          this.selectedTopicContentType.splice(index,1);
          this.topicContentTypeResult.filter(x=>x.key==event.source.value)[0].checked=false;
        }
      });
    }
    this.elasticSearchTopicCondition.ContentType=this.selectedTopicContentType;
    this.getTopicElasticResults();

  }
  area:string="";
  hideOtherTabsLoadNextPage:boolean;
  checkedOtherArea(event){
    if(event.checked)
    {
      this.selectedOtherArea.push(event.source.value);
    }
    else{
      this.selectedOtherArea.forEach((value,index) => {
        if(value==event.source.value)
        {
          this.selectedOtherArea.splice(index,1);
          this.otherAreaResult.filter(x=>x.key==event.source.value)[0].checked=false;
        }
      });
    }
    this.otherFilterExists=(this.selectedOtherContentType.length!=0 || this.selectedOtherArea.length!=0)?true:false;
    if(this.selectedOtherArea.length>0){
      this.hideOtherTabsLoadNextPage=true;
       this.area="";
       let count=0;
    this.selectedOtherArea.forEach(OtherAreaRes => {
      if(count==0){
        count++;
        this.area+=OtherAreaRes;
      }
      else{
        count++;
        this.area+=","+OtherAreaRes;
      }
    })
    
      forkJoin(this.httpCall.getElasticAnnotation(this.elasticSearchCondition.Searchterm, "", this.area),
        this.httpCall.getElasticBookmark(this.elasticSearchCondition.Searchterm, "", this.area)).subscribe(([annotation, bookmark]) => {
           this.annotationResult = annotation;
           this.bookmarkResult = bookmark;
        this.getOtherTabResult()
       })
    }
    else{
      this.hideOtherTabsLoadNextPage=(this.totalGlossaryCount==this.glossaryResultCount)?true:false;
      this.getOtherTabResult()
    }
  }

  checkedOtherContentType(event) {
    if (event.checked) {
      this.selectedOtherContentType.push(event.source.value[0]);
    }
    else {
      this.selectedOtherContentType.forEach((value, index) => {
        if (value == event.source.value[0]) {
          this.selectedOtherContentType.splice(index, 1);
        }
      });
    }
    this.GlossaryChecked = this.selectedOtherContentType.includes("Glossary");
    this.AnnotationChecked = this.selectedOtherContentType.includes("My annotations");
    this.BookmarkChecked = this.selectedOtherContentType.includes("My bookmarks");
    this.selectedOtherArea=( !this.selectedOtherContentType.includes("My annotations") || !this.selectedOtherContentType.includes("My bookmarks") )?[]:this.selectedOtherArea;
    this.hideOtherTabsLoadNextPage=(!this.selectedOtherContentType.includes("Glossary"))?true:false;
    this.otherFilterExists=(this.selectedOtherContentType.length!=0 || this.selectedOtherArea.length!=0)?true:false;
    this.getOtherTabResult();
    this.ShowOtherAreaFilter=(this.selectedOtherContentType.includes("My annotations") || this.selectedOtherContentType.includes("My bookmarks"))?true:false;
  }
  AnnotationChecked:boolean=false;
  BookmarkChecked:boolean=false;
  GlossaryChecked:boolean=false;
  ShowOtherAreaFilter:boolean=false;
  getOtherTabResult()
  {
    if (this.selectedOtherContentType.length == 0 && this.selectedOtherArea.length==0) {
      this.ShowOtherAreaFilter=false;
      this.glossarySearchResult = this.tempGlossarySearchResult;
      this.contacts=this.tempContacts;
      if (this.totalGlossaryCount == this.glossaryResultCount) {
      this.hideOtherTabsLoadNextPage=true; 
      this.annotationResult = this.tempannotationResult;
      this.bookmarkResult = this.tempBookmarkResult;
      }
      else{
        this.hideOtherTabsLoadNextPage=false; 
        this.annotationResult = [];
        this.bookmarkResult = [];
      }
    }
    if(this.selectedOtherArea.length==0){
      if (this.selectedOtherContentType.includes("My annotations") && this.selectedOtherContentType.length > 0) {
        this.annotationResult = this.tempannotationResult;
      }
      if (this.selectedOtherContentType.length > 0 && (!this.selectedOtherContentType.includes("My annotations"))) {
        this.annotationResult = [];
      }
      if (this.selectedOtherContentType.includes("My bookmarks") && this.selectedOtherContentType.length > 0) {
        this.bookmarkResult = this.tempBookmarkResult;
      }
      if (this.selectedOtherContentType.length > 0 && (!this.selectedOtherContentType.includes("My bookmarks"))) {
        this.bookmarkResult = [];
      }
    }
    if (this.selectedOtherContentType.includes("Glossary") && this.selectedOtherContentType.length > 0) {
      this.contacts=this.tempContacts;
      this.glossarySearchResult = this.tempGlossarySearchResult;
    }
    if ((!this.selectedOtherContentType.includes("Glossary")) && this.selectedOtherContentType.length > 0) {
      this.glossarySearchResult = [];
      this.contacts=[];
    }
    if (this.selectedOtherContentType.includes("My annotations") && !this.selectedOtherContentType.includes("My bookmarks")) {

      if (this.selectedOtherArea.length > 0) {
        this.bookmarkResult=[];
      }
      this.setOtherAreaResult();
      this.otherAreaResult.forEach((annotationRes,index) => {
        var annotationExists=annotationRes.dataFrom.find(x=>x.key=='annotation');
        if(annotationExists!=null && annotationExists!=undefined)
        {
          annotationRes.docCount=annotationRes.dataFrom.find(x=>x.key=='annotation')?.docCount;
        }
        else{
          this.otherAreaResult.splice(index, 1);
        }
      });
      this.getOtherAreaResultCheckedStatus()
    }
    else if (!this.selectedOtherContentType.includes("My annotations") && this.selectedOtherContentType.includes("My bookmarks")) {
      if (this.selectedOtherArea.length > 0) {
        this.annotationResult=[];
      }
      this.setOtherAreaResult();
      this.otherAreaResult.forEach((bookmarkRes,index) => {
        var bookmarkExists=bookmarkRes.dataFrom.find(x=>x.key=='bookmark');
        if(bookmarkExists!=null && bookmarkExists!=undefined)
        {
          bookmarkRes.docCount=bookmarkRes.dataFrom.find(x=>x.key=='bookmark')?.docCount;
        }
        else{
          this.otherAreaResult.splice(index, 1);
        }
      
      });
     this.getOtherAreaResultCheckedStatus()
    }
    else if ((this.selectedOtherContentType.includes("My annotations") && this.selectedOtherContentType.includes("My bookmarks"))|| (!this.selectedOtherContentType.includes("My annotations") && !this.selectedOtherContentType.includes("My bookmarks"))) {
      this.setOtherAreaResult();
      let count=0;
      this.area="";
      this.selectedOtherArea.forEach(OtherAreaRes => {
        var index = this.otherAreaResult.findIndex((obj => obj.key == OtherAreaRes));
        this.otherAreaResult[index].checked = true;

        if(count==0){
          count++;
          this.area+=OtherAreaRes;
        }
        else{
          count++;
          this.area+=","+OtherAreaRes;
        }
      })
       if(this.selectedOtherArea.length>0){
         forkJoin(this.httpCall.getElasticAnnotation(this.elasticSearchCondition.Searchterm, "", this.area),
           this.httpCall.getElasticBookmark(this.elasticSearchCondition.Searchterm, "", this.area)).subscribe(([annotation, bookmark]) => {
             this.annotationResult = annotation;
             this.bookmarkResult = bookmark;
           if(this.selectedOtherContentType.length == 0){
             this.contacts=[];
           }
         })
       }
      
    }

    if(this.selectedOtherContentType.length>0){
      this.totalOtherCount=this.selectedOtherContentType.includes("Glossary") ? this.annotationResult.length + this.bookmarkResult.length + this.totalGlossaryCount : this.annotationResult.length + this.bookmarkResult.length;
      this.otherCount = this.selectedOtherContentType.includes("Glossary") ? this.annotationResult.length + this.bookmarkResult.length + this.glossaryResultCount : this.annotationResult.length + this.bookmarkResult.length;
    }
    else{
      this.otherCount = this.annotationResult?.length + this.bookmarkResult?.length + this.glossaryResultCount;
      this.totalOtherCount = this.annotationCount + this.bookmarkCount + this.totalGlossaryCount;
    }
  }
  setOtherAreaResult()
  {
     this.otherAreaResult=[];
     if(this.selectedOtherContentType.includes("My annotations")){
      this.tempannotationResult.forEach(annotationRes => {
        if(annotationRes!=null && annotationRes.area!=null){
          const KeyExists = this.otherAreaResult.some(el => el.key === annotationRes.area);
          if(!KeyExists){
            let obj={
              key:annotationRes.area,
              docCount:1,
              dataFrom:[{
               key: ["annotation"],
               docCount:1
              }]
            }
            this.otherAreaResult.push(obj)
          }
          else{
            this.otherAreaResult.find(el => el.key === annotationRes.area).docCount += 1;
            this.otherAreaResult.find(el => el.key === annotationRes.area).dataFrom.filter(x=>x.key=='annotation')[0].docCount += 1;
          }
         
       }
     });
     }
     if(this.selectedOtherContentType.includes("My bookmarks")){
    this.tempBookmarkResult.forEach(bookmarkRes => {
      if(bookmarkRes!=null && bookmarkRes.area!=null){
        const KeyExists = this.otherAreaResult.some(el => el.key === bookmarkRes.area);
        if(!KeyExists){
          let obj={
            key:bookmarkRes.area,
            docCount:1,
            dataFrom:[{
              key: ["bookmark"],
              docCount:1
             }]
          }
          this.otherAreaResult.push(obj)
        }
        else{
          let obj={
            key: ["bookmark"],
            docCount:1
          }
          this.otherAreaResult.find(el => el.key === bookmarkRes.area).docCount+=1;
          this.otherAreaResult.find(el => el.key === bookmarkRes.area).dataFrom.push(obj);
          this.otherAreaResult.find(el => el.key === bookmarkRes.area).dataFrom.filter(x=>x.key=='bookmark')[0].docCount += 1;
          
          
        }
        
      }
    });
  }
  }
  
  getOtherAreaResultCheckedStatus(){
    // this.selectedOtherContentType.forEach(type => {
      // if (type.includes("Glossary")){
      //   this.GlossaryChecked=true;
      // }
      // if (type.includes("My annotations")){
      //   this.AnnotationChecked=true;
      // }
      // if (type.includes("My bookmarks")){
      //   this.BookmarkChecked=true;
      // }

      this.GlossaryChecked=this.selectedOtherContentType.includes("Glossary")?true:false;
      this.AnnotationChecked=this.selectedOtherContentType.includes("My annotations")?true:false;
      this.BookmarkChecked=this.selectedOtherContentType.includes("My bookmarks")?true:false;
    // })

    this.selectedOtherArea.forEach(x => {
      var index = this.otherAreaResult.findIndex((obj => obj.key == x));
      this.otherAreaResult[index].checked = true;
    })
  }

  setFocus() {
    document.getElementById("searchPage").scroll(0, 0);
  }

  enableBackToTop: boolean = false;

  EnableBackToTop() {

    // var div = document.getElementById("scrollList");
    // var div1 = document.getElementById("searchPage");
    // var div2 = document.getElementsByClassName("left-scrollbar")[0];
    var div = document.getElementById("searchPage");
    if (div != null) {
      var hasVerticalScrollbar = div.scrollHeight > div.clientHeight;

      if (hasVerticalScrollbar) {
        this.enableBackToTop = true;
      }
      else {
        this.enableBackToTop = false;
      }
    }
  }

  loadNextPage(tab:string) {
    if(tab=="paragraphTab")
    {
      this.paragraphPageCount += 1;
      this.graphQlService.GetParagraphElasticSearchReasult(this.elasticSearchCondition,this.paragraphPageCount).subscribe(paraRes=>{
        this.paragraphSearchResult=this.tempParagraphSearchResult;
        this.paragraphSearchResult=this.paragraphSearchResult.concat(paraRes?.hits?.hitsList)
        this.paragraphResultCount= this.paragraphResultCount+paraRes?.hits?.hitsList?.length;
        this.tempParagraphSearchResult=this.paragraphSearchResult;
      })
    }
    else if(tab=="topicsTab")
    {
      this.topicPageCount += 1;
      this.graphQlService.GetTopicSearchResults(this.elasticSearchTopicCondition,this.topicPageCount).subscribe(topicRes=>{
        this.topicSearchResult=this.tempTopicSearchResult;
        this.topicSearchResult=this.topicSearchResult.concat(topicRes?.hits?.hitsList)
        this.topicResultCount= this.topicResultCount+topicRes?.hits?.hitsList?.length;
        this.tempTopicSearchResult=this.topicSearchResult;
      })
    }
    else if(tab=="otherSourceTab")
    {
      if (this.totalOtherSourceResultCount != this.otherSourceResultCount && this.totalOtherSourceCount!=0 && ((this.selectedOtherSourceArea.length == 0 && this.selectedPdfSource.length == 0) || (this.selectedOtherSourceArea.length > 0 && this.selectedPdfSource.length > 0))) {
        this.othersourcePageCount += 1;
        this.graphQlService.GetOtherSourceSearchResults(this.elasticSearchCondition, this.othersourcePageCount).subscribe(otherSourceRes => {
          this.otherSourceSearchResult = this.tempOtherSourceSearchResult;
          this.otherSourceSearchResult = this.otherSourceSearchResult.concat(otherSourceRes?.hits?.hitsList)
          this.otherSourceResultCount = this.otherSourceResultCount + otherSourceRes?.hits?.hitsList?.length;
          this.tempOtherSourceSearchResult = this.otherSourceSearchResult;
          this.otherSourceCount = this.otherSourceResultCount;
          if (this.totalOtherSourceResultCount == this.otherSourceResultCount && this.selectedPdfSource.length==0 || this.selectedPdfSource.length) {
            this.pdfPageCount = this.pdfSearchResult.length == 0 ? 0 : this.pdfPageCount++;
            this.pdfSearchResult = this.tempPdfSearchResult;
            this.otherSourceCount = this.otherSourceResultCount + this.pdfSearchResultCount;
          }
        })
      }
    else if (this.totalOtherSourceResultCount == this.otherSourceResultCount && ((this.selectedOtherSourceArea.length == 0 && this.selectedPdfSource.length == 0) || (this.selectedOtherSourceArea.length > 0 && this.selectedPdfSource.length > 0))) {
      this.pdfPageCount += 1;
      this.graphQlService.GetPdfSearchResults(this.elasticSearchCondition, this.pdfPageCount).subscribe(pdfResult => {
        this.pdfSearchResult = this.pdfSearchResult.concat(pdfResult?.hits?.hitsList);
        this.pdfSearchResultCount = this.pdfSearchResultCount + pdfResult?.hits?.hitsList?.length;
        this.tempPdfSearchResult = this.pdfSearchResult;
        this.otherSourceCount = this.otherSourceResultCount + this.pdfSearchResultCount;
      })
    }
      else if (this.selectedOtherSourceArea.length > 0 && this.selectedPdfSource.length==0) {
        this.othersourcePageCount += 1;
        this.graphQlService.GetOtherSourceSearchResults(this.elasticSearchCondition, this.othersourcePageCount).subscribe(otherSourceRes => {
          this.otherSourceSearchResult = this.tempOtherSourceSearchResult;
          this.otherSourceSearchResult = this.otherSourceSearchResult.concat(otherSourceRes?.hits?.hitsList);
          this.otherSourceResultCount = this.otherSourceResultCount + otherSourceRes?.hits?.hitsList?.length;
          this.tempOtherSourceSearchResult = this.otherSourceSearchResult;
          this.otherSourceCount = this.otherSourceResultCount;
        })
    }
      else if (this.selectedOtherSourceArea.length == 0 && this.selectedPdfSource.length > 0) {
      this.pdfPageCount += 1;
      this.graphQlService.GetPdfSearchResults(this.elasticSearchCondition, this.pdfPageCount).subscribe(pdfResult => {
        this.pdfSearchResult = this.pdfSearchResult.concat(pdfResult?.hits?.hitsList);
        this.pdfSearchResultCount = this.pdfSearchResultCount + pdfResult?.hits?.hitsList?.length;
        this.tempPdfSearchResult = this.pdfSearchResult;
        this.otherSourceCount = this.pdfSearchResultCount;
      })
    }
     
    }
    else{
      this.otherPageCount = this.otherPageCount + 1;
      this.getGlossaryContent();
    }
  }

  getGlossaryContent() {
   this.graphQlService.GetMasterGlossarySearchResult(this.elasticSearchCondition.Searchterm,this.otherPageCount).subscribe(glossaryContent => {
     if(glossaryContent){
      this.mapGlossaryContent(glossaryContent?.hits?.hitsList);
      this.hideOtherTabsLoadNextPage=false;
      this.getOtherTabResult();
      if (this.totalGlossaryCount == this.glossaryResultCount) {
       this.hideOtherTabsLoadNextPage=true;
       this.annotationResult = this.tempannotationResult;
       this.bookmarkResult = this.tempBookmarkResult;
       this.setOtherAreaResult();
     }
     }
    
   });
    
  }

  openLinkById(event) {

    event.preventDefault();
    this.openlink.openLinkById(event);
  }
  OpenLink(event) {
    const path : any = event.composedPath() as Array<any>;
    event.preventDefault();
    const xref = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "xref");
    var searchTerm=event.target.innerText;
    var dataLink=event.target.dataset.link;
   
    if (xref && isNaN(Number(searchTerm.split("-")[0])) && !searchTerm.toLocaleLowerCase().includes(("Accounting Standards Update").toLocaleLowerCase()) && !searchTerm.toLocaleLowerCase().includes(("subsection").toLocaleLowerCase())) {
      let href = xref.getAttribute('href').split("/");
      let guid = xref.getAttribute('href').includes('#') ? xref.getAttribute('href').split('#')[1] : href[href.length - 1];
      this.commonDataService.glossaryTermId.next(guid);
      this.commonDataService.showRightPanel.next(true);
      this.commonDataService.rightOverlayOption.next("inline-glossary");
      this.commonDataService.rightPanelWidth.next("rightOverLay_small");

    }
    else if(dataLink=="contentPage" || event.target.className.includes("ditamap") || event.target.className.includes("pdf-link")){
      this.openleftnavlink.GetLeftNavLink(event);
    }
    else if(dataLink==undefined && dataLink==null && (!isNaN(Number(searchTerm.split("-")[0])) || searchTerm.toLocaleLowerCase().includes(("Accounting Standards Update").toLocaleLowerCase())||searchTerm.toLocaleLowerCase().includes(("subsection").toLocaleLowerCase()))){
      let href = xref.getAttribute('href');
      let UrlParts = href.split("/");
      if (searchTerm.includes("(")) {
        searchTerm = searchTerm.split("(")[0];
      }
      if (searchTerm.includes("[")) {
        searchTerm = searchTerm.split("[")[0];
      }
      if (searchTerm.includes("to")) {
        searchTerm = searchTerm.split(" to")[0];
      }
      if (searchTerm.includes("through")) {
        searchTerm = searchTerm.split(" through")[0];
      }
      let url = !isNaN(Number(searchTerm.split("-")[0])) ? "/" + UrlParts[1] + "/" + UrlParts[2] + "/" + searchTerm : "/" + UrlParts[1] + "/" + UrlParts[2];
      this.route.navigateByUrl(url);
    }

  }

  openSitesPdf(event,pdfUrl:string){
    // this.graphQLService.getS3BucketSitesImagePath().subscribe(baseUrl=>{
    //   if(baseUrl){
    //     let url = baseUrl + "/" + pdfUrl;
    //         window.open(url);
    //   }
    // })
    this.openlink.openLinkById(event,true);
  }

  addPendingContent() {
    let ImageDivs = document.getElementsByClassName("pending-text") as HTMLCollectionOf<HTMLElement>;
    if (ImageDivs != null && ImageDivs.length > 0) {

      for (let i = 0; i < ImageDivs.length; i++) {
        let normText = document.getElementsByClassName("norm-text") as HTMLCollectionOf<HTMLElement>;
        if (i == 0 && normText.length == 0) {
          ImageDivs[i].className += " mt-0";
        }
        let pending_content_text_div = document.getElementsByClassName("pending-question-icon") as HTMLCollectionOf<HTMLElement>;
        if (pending_content_text_div != null && pending_content_text_div.length == 0) {
          let divBlock = document.createElement("div");
          divBlock.setAttribute("id", "pending-content-text")
          let img = document.createElement("img");
          img.src = "../../../../assets/icons/clock-black.svg";
          img.alt = "Clock Image";
          img.className = "pending-clock-icon"
          let imgQuestion = document.createElement("img");
          imgQuestion.src = "../../../../assets/icons/Help.svg";
          imgQuestion.alt = "Question Image";
          imgQuestion.className = "pending-question-icon";
          let textBlock = document.createElement("span");
          textBlock.innerText = "PENDING CONTENT";
          textBlock.className = "mat-Info";
          divBlock.appendChild(img);
          divBlock.appendChild(textBlock);
          divBlock.appendChild(imgQuestion);
          divBlock.className = "bottomMargin";
          ImageDivs[i].insertBefore(divBlock, ImageDivs[i].firstChild);
        }

        let dateSection = document.getElementsByClassName("date-effective") as HTMLCollectionOf<HTMLElement>;

        if (dateSection.length > 0) {
          for (let j = 0; j < dateSection.length; j++) {
            let divBlock1 = document.createElement("div");
            divBlock1.className = "mt-1rem";
            dateSection[j].insertBefore(divBlock1, dateSection[j].firstChild);
            dateSection[j].innerHTML = dateSection[j].innerHTML.replace("(P)", '<img src="../../../../assets/icons/P-FASB.svg" class="close-nav-icon-right-overlay" alt="Pending FASB P">');
            dateSection[j].innerHTML = dateSection[j].innerHTML.replace("(N)", '<img src="../../../../assets/icons/N-FASB.svg" class="close-nav-icon-right-overlay" alt="Pending FASB N">');

            let guidanceLink = dateSection[j].nextElementSibling;
            if (guidanceLink.tagName.toLowerCase() === 'a' && guidanceLink.className == "xref") {
              guidanceLink.insertAdjacentHTML('afterend', "<div></div>");
            }
          }
        }
      }
    }
  }

  onRightClick(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "xref") {
      let ahref = event.srcElement.innerText;
      if (ahref.includes("(")) { ahref = ahref.split("(")[0]; }
      if (ahref.includes("[")) { ahref = ahref.split("[")[0]; }
      if (ahref.includes("to")) { ahref = ahref.split(" to")[0]; }
      if (ahref.includes("through")) { ahref = ahref.split(" through")[0]; }
      if (ahref.includes("-")) {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + ahref);
      }
      else {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        let otherSourceUrlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
        event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlLastPart);
      }
    }
  }

  navPathTreeCall$: Subscription;
  mouseOverFunctions(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "ditamap") {
      let ahref = event.srcElement.innerText;
      let navPath = ahref.split("-");
      if (navPath.length >= 3) {
        let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
        if (tempData != undefined && tempData != null) {
          let navPathUrl: string = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
          event.srcElement.setAttribute("href", "/" + navPathUrl.split("/")[0] + "/" + navPathUrl.split("/")[1] + "/" + ahref);
        }
        else {
          this.navPathTreeCall$ = this.graphQLService.getNavPathTree(navPath[0] + "-" + navPath[1] + "-" + navPath[2]).subscribe(data => { event.srcElement.setAttribute("href", "/" + data[0].itemLink.split("/")[0] + "/" + data[0].itemLink.split("/")[1] + "/" + ahref); });
        }
      }
      else {
        event.srcElement.setAttribute("href", "/" + ahref + "/tableOfContent");
      }
    }
  }

  getBreadcrumbWithNavPath(breadcerumbUrl) {
    let navPathUrl = "";
    for (let i = 0; i < 9; i++) {
      let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
      if (tempData[i].itemData != null) {
        for (let j = 0; j < tempData[i].itemData.length; j++) {
          if (tempData[i].itemData[j]?.navPath?.startsWith(breadcerumbUrl)) {
            navPathUrl = tempData[i].itemData[j]?.itemLink;
            return navPathUrl;
          } else {
            if (tempData[i].itemData[j].itemData != null) {
              for (let k = 0; k < tempData[i].itemData[j].itemData.length; k++) {
                if (tempData[i].itemData[j].itemData[k]?.navPath?.startsWith(breadcerumbUrl)) {
                  navPathUrl = tempData[i].itemData[j].itemData[k]?.itemLink;
                  return navPathUrl;
                } else {
                  if (tempData[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < tempData[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (tempData[i].itemData[j].itemData[k].itemData[l]?.navPath?.startsWith(breadcerumbUrl)) {
                        navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l]?.itemLink;
                        return navPathUrl;
                      }
                      else {
                        if (tempData[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < tempData[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.startsWith(breadcerumbUrl)) {
                              navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.itemLink;
                              return navPathUrl;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return "";
  }

  handleInputChange() {
    
    let inputElement = document.getElementById("searchInput") as HTMLInputElement;
    if (inputElement.value.trim() !== '') {
      this.selectedTopicArea = [];
      this.elasticSearchCondition.TopicId = [];
      this.topicAreaResult.forEach(c => {
        c.checked = false;
      })

      this.selectedParagraphArea = [];
      this.elasticSearchCondition.Area = [];
      this.paragraphAreaResult.forEach(c => {
        c.checked = false;
      })

      this.elasticSearchTopicCondition.Area = [];
      this.selectedOtherContentType = [];
      this.selectedOtherArea = [];
      this.otherAreaResult.forEach(c => {
        c.checked = false;
      })
      this.selectedOtherSourceArea = [];
      this.elasticSearchCondition.OtherSourceDocType = [];
      this.OtherSourceAreaResult.forEach(c => {
        c.checked = false;
      })
      this.selectedTopicContentType = [];
      this.topicContentTypeResult.forEach(c => {
        c.checked = false;
      })
      this.selectedParagraphContentType = [];
      this.paragraphContentTypeResult.forEach(c => {
        c.checked = false;
      })
      this.GlossaryChecked = false;
      this.AnnotationChecked = false;
      this.BookmarkChecked = false;
      this.isFilterLocked = true;
      this.isButtonActive = true;
    } else {
      this.isButtonActive = false;
    }
   
  }
  whenCross() {
    let inputElement = document.getElementById("searchInput") as HTMLInputElement;
    inputElement.value = "";
    //clear filters
    this.selectedTopicArea = [];
    this.elasticSearchCondition.TopicId = [];
    this.topicAreaResult.forEach(c => {
      c.checked = false;
    })

    this.selectedParagraphArea = [];
    this.elasticSearchCondition.Area = [];
    this.paragraphAreaResult.forEach(c => {
      c.checked = false;
    })

    this.elasticSearchTopicCondition.Area = [];
    this.selectedOtherContentType = [];
    this.selectedOtherArea = [];
    this.otherAreaResult.forEach(c => {
      c.checked = false;
    })
   
    this.selectedOtherSourceArea = [];
    this.elasticSearchCondition.OtherSourceDocType = [];
    this.OtherSourceAreaResult.forEach(c => {
      c.checked = false;
    })
    this.selectedTopicContentType = [];
    this.topicContentTypeResult.forEach(c => {
      c.checked = false;
    })
    this.selectedParagraphContentType = [];
    this.paragraphContentTypeResult.forEach(c => {
      c.checked = false;
    })
    this.GlossaryChecked = false;
    this.AnnotationChecked = false;
    this.BookmarkChecked = false;
    this.isFilterLocked = true;
    this.handleInputChange();
  }
  changeBool() {
    //this.isButtonActive = true;
  }
  sendSearch() {
    if (this.isButtonActive == true) {
      this.isButtonActive = false;
      let inputElement = document.getElementById("searchInput") as HTMLInputElement;
      let term = inputElement.value;
      localStorage.setItem("ElasticSearchTerm", term);
      this.getSearchInputValues();
      if (term) {
        this.route.navigate([], {
          queryParams: { query: term },
          queryParamsHandling: 'merge'
        });
      }
    }
  }
}
